import { render, staticRenderFns } from "./SpeechBubble.vue?vue&type=template&id=15d28ab6&scoped=true&"
import script from "./SpeechBubble.vue?vue&type=script&lang=js&"
export * from "./SpeechBubble.vue?vue&type=script&lang=js&"
import style0 from "./SpeechBubble.vue?vue&type=style&index=0&id=15d28ab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d28ab6",
  null
  
)

export default component.exports